import { render, staticRenderFns } from "./repairInformation.vue?vue&type=template&id=6a630a94&scoped=true&"
import script from "./repairInformation.vue?vue&type=script&lang=js&"
export * from "./repairInformation.vue?vue&type=script&lang=js&"
import style0 from "./repairInformation.vue?vue&type=style&index=0&id=6a630a94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a630a94",
  null
  
)

export default component.exports